// Танаки — passive (v6): «В Фазе 1 каждого хода, начиная со 2-го, +1 Влияния».
// Срабатывает в onTurnStart (до тяги карт).
//
// v6 dsl_trigger1: event=turn_start, target=self, effect=influence_gain,
// value=1, condition=turn_number_ge_2.
//
// До C.1 здесь была старая способность «+0/1/1 самому слабому юниту» —
// заменена на v6-вариант (БУГ.18).

import { addInfluence } from './influence.js';

export const HERO_ID = 'deus_tanaki';

export function tanakiPassiveOnTurnStart(state, ownerIdx) {
  const p = state.players[ownerIdx];
  if (!p || p.hero.id !== HERO_ID) return;
  if (p.hero.hp <= 0) return;
  // Со 2-го хода — +1 Влияния. addInfluence сам проверяет фракцию (только
  // Деус), потолок 0..10 и блок Манипуляции.
  if ((state.currentTurn ?? 0) < 2) return;
  addInfluence(state, ownerIdx, 1, 'Танаки');
}
